var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"swiper",rawName:"v-swiper",value:(_vm.swiperOption),expression:"swiperOption"}]},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"})])}
var staticRenderFns = []

export { render, staticRenderFns }